import { alpha, Chip, styled } from '@/shared/ui/mui';
/**
 * FilterChip - Deletable chip for active filters
 *
 * A purple-themed chip component designed for displaying active filters
 * with delete functionality. Features prominent styling with white text
 * on purple background.
 *
 * @example
 * ```tsx
 * <FilterChip
 *   label="Italian"
 *   onDelete={() => removeFilter('cuisine')}
 * />
 * ```
 */
export const FilterChip = styled(Chip)(({ theme }) => ({
  margin: '4px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  fontWeight: 'medium',
  '& .MuiChip-deleteIcon': {
    color: theme.palette.primary.contrastText,
    '&:hover': {
      color: alpha(theme.palette.primary.contrastText, 0.8),
    },
  },
}));
